import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import Config from '../../../Config';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { ErrorType, MessageContent, PopUp, EnumStep } from './General';
import { dispatch } from 'd3';
const ResetSelection = '-';

export const UploadUsersList = createAsyncThunk('organizationPortal/UploadOrgUsersList', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const UploadOrgUsersReq = {
      file: {
        fileType: data.extension.toUpperCase(),
        capchaValue: data.capchaValue,
        fileName: data.fileName,
        FileContentBase64: data.fileInBase64,
        orgId: data.orgId,
      },
      portalLink: data.actionType == 'activate' ? Config.organizationPortalUrlActivate : Config.organizationPortalUrlUpgrade,
      actionType: data.actionType,
    };
    var result = await ProviderManager.getProviderData('UploadOrgUsersList', UploadOrgUsersReq);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return { ...state, error: true };
  }
});

export const findUserByNameOrByPhone = createAsyncThunk('orgUsersManagement/FindUserByNameOrByPhone', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var state = thunkAPI.getState().orgUsersManagement;
    const Req = {
      orgId: state.selectedHetPay,
      searchType: data.type,
      searchValue: data.value,
      pageNo: state.dataIndexToLoad,
    };
    const result = await ProviderManager.getProviderData('FindUserByNameOrByPhone', Req);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const GetOrgUserList = createAsyncThunk('orgUsersManagement/GetOrgUserList', async (data, thunkAPI) => {
  try {
    var state = thunkAPI.getState().orgUsersManagement;
    if (state.dataIndexToLoad == 0 && state.currentDataIndex == 0) {
      thunkAPI.dispatch(showAppLoader());
    }
    var orgId = thunkAPI.getState().portalsBlock.selectedHetPay ?? state.selectedHetPay;
    const Req = {
      filterList: [...state.filterList],
      orderList: [...state.orderList],
      pageNo: state.dataIndexToLoad,
      orgId,
      actionType: state.actionType,
    };
    const result = await ProviderManager.getProviderData('GetOrgUserList', Req);
    if (state.dataIndexToLoad == 0) {
      thunkAPI.dispatch(hideAppLoader());
    }
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});
export const getUpdatablePermissionsByUser = createAsyncThunk(
  'orgUsersManagement/GetUpdatablePermissionsByUser',
  async (data, thunkAPI) => {
    try {
      var state = thunkAPI.getState().orgUsersManagement;
      thunkAPI.dispatch(showAppLoader());
      const Req = {
        userId: data.userId,
        phoneNumber: data.subscriberNumber,
        orgId: state.selectedHetPay,
      };

      const result = await ProviderManager.getProviderData('GetUpdatablePermissionsByUser', Req);

      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      throw error;
    }
  },
);

export const deleteOrgUser = createAsyncThunk('orgUsersManagement/DeleteOrgUser', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var state = thunkAPI.getState().orgUsersManagement;
    const Req = {
      userId: state.selectedUser.userId,
      phoneNumber: state.selectedUser.subscriberNumber,
      orgId: state.selectedHetPay,
      ban: state.selectedUser.ban,
    };

    const result = await ProviderManager.getProviderData('DeleteOrgUser', Req);

    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const sendLinkToUser = createAsyncThunk('orgUsersManagement/SendOrgPortalLinkToUser', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var state = thunkAPI.getState().orgUsersManagement;
    const Req = {
      userId: state.selectedUser.userId,
      phoneNumber: state.selectedUser.subscriberNumber,
      PortalLink: state.actionType == 'activate' ? Config.organizationPortalUrlActivate : Config.organizationPortalUrlUpgrade,
      orgId: state.selectedHetPay,
      actionType: state.actionType,
    };
    const result = await ProviderManager.getProviderData('SendOrgPortalLinkToUser', Req);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const updateOrgUserByContact = createAsyncThunk('orgUsersManagement/UpdateOrgUserByContact', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var state = thunkAPI.getState().orgUsersManagement;
    var user = state.selectedUser;
    user = { firstName: user.fullName.split(' ')[0], lastName: user.fullName.split(' ')[1], orgId: state.selectedHetPay, ...user };
    const result = await ProviderManager.getProviderData('UpdateOrgUserByContact', user);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

const initialState = {
  usersList: [],
  tempUsersList: [],
  filterList: [],
  orderList: [],
  userTypeList: [],
  statusList: [],
  planList: [],
  messageContent: '',
  showPopup: false,
  currentPage: 0,
  currentDataIndex: 0,
  dataIndexToLoad: 0,
  searchValue: '',
  currentStep: EnumStep.UploadFile,
  updatePermission: {},
  currentPopup: '',
  messageData: '',
  error: '',
  selectedUser: '',
  countOfRows: '0',
  showLastList: false,
  selectedHetPay: '',
  actionType: '',
};

const OrgManagementPortalSlice = createSlice({
  name: 'orgUsersManagement',
  initialState: initialState,
  reducers: {
    saveToHistory: (state, action) => {
      return state;
    },
    setOrderList: (state, action) => {
      const orderIndex = state.orderList.findIndex((order) => order.orderType === action.payload);
      if (orderIndex !== -1) {
        const newOrders = [...state.orderList];
        newOrders[orderIndex]['descending'] = !newOrders[orderIndex].descending;
      } else {
        state.orderList = [...state.orderList, { orderType: action.payload, descending: 0 }];
      }
    },
    setFilterList: (state, action) => {
      if (!action.payload) {
        state.filterList = [];
      } //reset
      else if (state.filterList.length > 0) {
        const filterIndex = state.filterList.findIndex((filter) => filter.type === action.payload.type);
        if (filterIndex !== -1) {
          if (action.payload.value !== ResetSelection) {
            state.filterList[filterIndex]['value'] = action.payload.value;
          } else {
            state.filterList.splice(filterIndex, 1);
          }
        } else {
          state.filterList = [...state.filterList, action.payload];
        }
      } else {
        state.filterList = [action.payload];
      }
      state.currentPage = 0;
      state.currentDataIndex = 0;
      state.currentDataIndex = 0;
      return state;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload;
      return state;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
      return state;
    },
    setDataIndexToLoad: (state, action) => {
      state.dataIndexToLoad = action.payload;
      return state;
    },
    setCurrentDataIndex: (state, action) => {
      state.currentDataIndex = action.payload;
      return state;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    setUsersList: (state, action) => {
      state.showLastList = false;
      var lastUserList = state.usersList;
      state.usersList = state.tempUsersList;
      state.tempUsersList = lastUserList;
      state.currentDataIndex = state.dataIndexToLoad;
      return state;
    },

    setShowLastList: (state, action) => {
      state.showLastList = action.payload;
      return state;
    },
    setShowPopUp: (state, action) => {
      state.showPopup = action.payload.show;
      state.messageData = { ...action.payload.message } ?? '';
      state.currentPopup = action.payload.type ?? '';
      return state;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
      return state;
    },
    resetTempList: (state, action) => {
      state.usersList = state.tempUsersList;
      state.tempUsersList = [];
      return state;
    },
    setSelectedHetPay: (state, action) => {
      state.selectedHetPay = action.payload;
      return state;
    },
    setActionType: (state, action) => {
      state.actionType = action.payload;
      return state;
    },
  },
  extraReducers: {
    [GetOrgUserList.fulfilled]: (state, action) => {
      var response = action.payload;
      if (response.organizationUsers?.length > 0) {
        state.currentStep = EnumStep.PortalManagement;
        state.userTypeList = response.userTypeList;
        state.statusList = response.statusList;
        state.planList = response.planList.filter((plan) => plan !== '');
        state.distributionCenterList = response.distributionCenterList;
        state.countOfRows = response.countOfRows;
        if (state.dataIndexToLoad == 0 && state.currentDataIndex == 0) {
          state.usersList = response.organizationUsers;
        } else {
          state.tempUsersList = response.organizationUsers;
        }
      } else {
        state.countOfRows = 0; //reset
      }
      return state;
    },
    [GetOrgUserList.rejected]: (state, action) => {
      state.currentPopup = PopUp.GeneralMessage;
      state.messageData = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },

    [findUserByNameOrByPhone.fulfilled]: (state, action) => {
      var response = action.payload;
      state.countOfRows = response.countOfRows;
      if (response.countOfRows > 0) {
        if (state.dataIndexToLoad == 0) {
          state.usersList = response.organizationUsers;
        } else {
          state.tempUsersList = response.organizationUsers;
        }
      }
      return state;
    },
    [findUserByNameOrByPhone.rejected]: (state, action) => {
      state.currentPopup = PopUp.GeneralMessage;
      state.messageData = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },
    [sendLinkToUser.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        state.messageData = MessageContent.SendLinkSucceeded;
      } else {
        state.messageData = MessageContent.GeneralError;
      }
      state.currentPopup = PopUp.GeneralMessage;
      state.showPopup = true;
      return state;
    },
    [sendLinkToUser.rejected]: (state, action) => {
      state.currentPopup = PopUp.GeneralMessage;
      state.messageData = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },
    [updateOrgUserByContact.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        state.usersList = state.usersList.map((user) => (user.userId == state.selectedUser.userId ? state.selectedUser : user));
        state.messageData = MessageContent.UpdateUserSucceeded;
      } else {
        state.messageData = MessageContent.GeneralError;
      }
      state.currentPopup = PopUp.GeneralMessage;
      state.showPopup = true;
      return state;
    },
    [updateOrgUserByContact.rejected]: (state, action) => {
      state.currentPopup = PopUp.GeneralMessage;
      state.messageData = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },
    [deleteOrgUser.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        state.usersList = state.usersList.filter((user) => user.userId !== state.selectedUser.userId);
        state.countOfRows = state.countOfRows - 1;
        state.messageData = MessageContent.DeleteUserSucceeded;
      } else {
        state.messageData = MessageContent.GeneralError;
      }
      state.currentPopup = PopUp.GeneralMessage;
      state.showPopup = true;
      return state;
    },
    [deleteOrgUser.rejected]: (state, action) => {
      state.messageData = MessageContent.GeneralError;
      state.currentPopup = PopUp.GeneralMessage;
      state.showPopup = true;
      return state;
    },
    [getUpdatablePermissionsByUser.fulfilled]: (state, action) => {
      var res = action.payload;
      state.selectedUser = {
        ...state.selectedUser,
        canRemoveUser: res.canRemoveUser,
        canUpdateFullRow: res.canUpdateFullRow,
        canUpdateDistributionCenter: res.canUpdateDistributionCenter,
      };
      if (res.errorMsg) {
        state.messageData = MessageContent[res.errorMsg];
        state.currentPopup = PopUp.GeneralMessage;
      } else {
        state.currentPopup = PopUp.UpdateUser;
      }
      state.showPopup = true;
      return state;
    },
    [getUpdatablePermissionsByUser.rejected]: (state, action) => {
      state.currentPopup = PopUp.GeneralMessage;
      state.messageData = MessageContent.GeneralError;
      state.showPopup = true;
      return state;
    },
  },
});

export const {
  saveToHistory,
  setFilterList,
  setOrderList,
  setCurrentPage,
  setUsersList,
  setDataIndexToLoad,
  setCurrentDataIndex,
  setShowPopUp,
  setSelectedUser,
  setCurrentStep,
  setSearchValue,
  setShowLastList,
  setSelectedHetPay,
  setActionType,
  resetTempList
} = OrgManagementPortalSlice.actions;

export default OrgManagementPortalSlice.reducer;
